import './App.css';

function PricingItem({ title }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <i className="pi pi-check"></i>
            <div style={{ marginLeft: '0.2em' }}>
                {title}
            </div>
        </div>
    );
}

export default PricingItem;